import React, { memo, useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import Loader from "react-js-loader";
import { ToastContainer, toast } from 'react-toastify';
import { getEndpointUrl } from "../../Utils/Common";

const ModalSetStatus = ({ onCallback, row, show, close, status }) => {

    const [isLoading, setLoading] = useState(false);

    const [userLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    useEffect(() => {

    }, [isLoading, row, status]);

    const onSetStatus = () => {
        setLoading(true);

        fetch(getEndpointUrl() + `/purchase/status/${row.id}`, {
            method: "PUT",
            body: new URLSearchParams({
                user_id: userLogin.id,
                status: status
            }),
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            setLoading(false);

            if (json.status === 'ok') {

                toast.success("Yay, Data pembayaran berhasil diubah.", {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                });

                onCallback(row);

                close()
            } else {
                toast.error(json.message, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true
                });
            }
        }).catch(error => {
            setLoading(false);
        });
    };
    return (
        <>
            <ToastContainer position="top-end" className="p-3"></ToastContainer>
            <Modal show={show} onHide={close} backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Ubah status ke <span className="text-uppercase">"{status}"</span>?</Modal.Title>
                </Modal.Header>
                {isLoading ?
                    <Modal.Body>
                        <div className="d-flex justify-content-center mt-5 mb-5">
                            <Loader type="bubble-scale" bgColor={"#E57373"} size={100} />
                        </div>
                    </Modal.Body>
                    :
                    <>
                        <Modal.Body>
                            <p className="mb-0">Yakin anda akan mengubah data ini?</p>
                            <p className="pt-0 mt-0"><span className={status == 'lunas' ? "text-success" : "text-warning"}>{row.invoice && row.invoice.customerName}</span></p>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={close}> Batal </Button>
                            <Button variant={status == 'lunas' ? "success" : "warning"} onClick={onSetStatus}>Ubah Status</Button>
                        </Modal.Footer>
                    </>
                }
            </Modal>
        </>
    );
}

export default memo(ModalSetStatus);
